import * as Sentry from '@sentry/react';
import 'animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { createUseStyles } from 'react-jss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { StorageProvider } from './hooks/use-storage';
import useWindowDimensions from './hooks/use-window-dimensions';
import { LoadingMenuScreen } from './screens/load/loading-menu-screen';
import { RedirectOldScreen } from './screens/load/redirect-old-screen';
import { layoutDefaults } from './utils/layout-defaults';
import { analyticsSetup } from './utils/setup/analytics-setup';
import { axiosSetup, useAxiosLog } from './utils/setup/axios-setup';
import { sentrySetup } from './utils/setup/sentry-setup';

// https://github.com/airbnb/javascript/tree/master/react
// https://cssinjs.org/react-jss?v=v10.6.0
// https://www.npmjs.com/package/react-floating-button

axiosSetup();
sentrySetup();
analyticsSetup();

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
  const { initial } = useWindowDimensions();
  const classes = useStyles(initial);
  useAxiosLog();

  return (
    <div className={isMobile ? null : classes.container}>
      <div className={isMobile ? null : classes.content}>
        <StorageProvider>
          <BrowserRouter>
            <SentryRoutes>
              <Route path="/s/:spotId" element={<LoadingMenuScreen />} />
              <Route path="/q/:qrCodeId" element={<LoadingMenuScreen />} />
              <Route path="/m/:menuId" element={<LoadingMenuScreen />} />
              <Route path="/c/:categoryId" element={<LoadingMenuScreen />} />
              <Route path="/i/:itemId" element={<LoadingMenuScreen />} />
              <Route path="/:menuSlug/*" element={<LoadingMenuScreen />} />
              <Route path="" exact element={<RedirectOldScreen />} />
            </SentryRoutes>
          </BrowserRouter>
        </StorageProvider>
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'grid',
    // background: layoutDefaults.primaryColor,
  },
  content: {
    width: '100%',
    maxWidth: (initial) =>
      isMobile ? initial?.width : layoutDefaults.maxScreenWidth,
    // alignSelf: 'center',
    justifySelf: 'center',

    // border: '1px solid red',
  },
});

export default App;
